import script from "./driverHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./driverHeader.vue?vue&type=script&setup=true&lang=js"

import "./driverHeader.vue?vue&type=style&index=0&id=14f7bed7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f7bed7"]])

export default __exports__